<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="年月">
              <el-select v-model="q.yearMonth" placeholder="请选择" clearable style="width:100%">
                <el-option v-for="item in yearMonthList" :key="item" :label="item" :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="平台商编码/名称">
              <el-input v-model="q.ptCodeName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料编码/名称">
              <el-input v-model="q.materialCodeName" placeholder="请输入" clearable/>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <!-- 暂时隐藏：生成报表按钮 -->
            <!--<el-button class="h-btn h-formBtn h-bggreen" @click="handleGenerate">生成报表</el-button>-->
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            ref="multipleTable"
            stripe border
            style="width: 100%"
            max-height="450"
        >
          <el-table-column prop="yearMonth" label="年月" width="90"/>
          <el-table-column prop="ptCode" label="平台商编码" width="120" show-overflow-tooltip/>
          <el-table-column prop="ptName" label="平台商名称" min-width="160" show-overflow-tooltip/>
          <el-table-column prop="materialCode" label="物料编码" width="120" show-overflow-tooltip/>
          <el-table-column prop="materialName" label="物料名称" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="openingStock" label="期初库存" width="90"/>
          <el-table-column prop="inQty" label="入库数量" width="90"/>
          <el-table-column prop="outQty" label="出库数量" width="90"/>
          <el-table-column prop="balance" label="结余数量" width="90"/>
          <el-table-column label="操作" width="90" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="goDetail(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableBL">
          <el-button class="h-btn h-formBtn h-bgblueQ" @click="exportExcel">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "@/api/SystemService";
import updownfile from "@/utils/updownfile";

export default {
  data() {
    return {
      q: {
        yearMonth: '',
        ptCodeName: '',
        materialCodeName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      yearMonthList: [],
    }
  },
  methods: {
    handleFilter() {
      this.q.pageNo = 1
      this.query()
    },
    resetData() {
      this.q = {
        yearMonth: '',
        ptCodeName: '',
        materialCodeName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.query()
    },
    query() {
      // 默认当前月
      if (!this.q.yearMonth) {
        let now = new Date();
        this.q.yearMonth = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0');
      }
      let params = { ...this.q }
      // 平台商编码/名称 联合搜索 → ptKeyword
      if (params.ptCodeName) {
        params.ptKeyword = params.ptCodeName
      }
      // 物料编码/名称 联合搜索 → materialKeyword
      if (params.materialCodeName) {
        params.materialKeyword = params.materialCodeName
      }
      ss.bscHhptInventoryReport.selectReportPage(params).then(res => {
        this.tableData = res.records;
        this.q.total = res.total;
      })
    },
    handleGenerate() {
      let yearMonth = this.q.yearMonth;
      if (!yearMonth) {
        let now = new Date();
        yearMonth = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0');
      }
      this.$confirm('确定要生成 ' + yearMonth + ' 月份的库存月报吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.bscHhptInventoryReport.generateReport(yearMonth).then(res => {
          if (res.f) {
            this.$message.success('报表生成成功');
            this.query();
            this.getYearMonths();
          }
        })
      }).catch(() => {});
    },
    exportExcel() {
      let params = { ...this.q }
      if (params.ptCodeName) {
        params.ptKeyword = params.ptCodeName
      }
      if (params.materialCodeName) {
        params.materialKeyword = params.materialCodeName
      }
      updownfile.down("/api/swyl/v1/inventoryReport/bscHhptInventoryReport/downloadExcel", params, "get", 'data');
    },
    goDetail(row) {
      this.$router.push({
        path: '/loud/inventoryRecord',
        query: {
          yearMonth: row.yearMonth,
          ptCode: row.ptCode,
          materialCode: row.materialCode
        }
      });
    },
    getYearMonths() {
      ss.bscHhptInventoryReport.getYearMonths().then(res => {
        if (res.f) {
          this.yearMonthList = res.obj || [];
        }
      })
    },
  },
  created() {
    this.getYearMonths();
    this.query();
  },
  activated() {
    this.query()
  }
}
</script>
<style lang="less" scoped>
</style>
